import { themecolors as defaultThemeColors } from '../../Layout/theme'

export const formDefault = {
  name: '',
  description: '',
  id: '',
}

export const getAccent = (themecolors = {}) =>
  themecolors['500'] ||
  themecolors.themeLightColor ||
  defaultThemeColors['500'] ||
  '#1a1d4f'

export const hexToRgba = (hex, alpha = 1) => {
  if (!hex || typeof hex !== 'string') return `rgba(0, 0, 0, ${alpha})`
  let h = hex.replace('#', '')
  if (h.length === 3) {
    h = h
      .split('')
      .map(c => c + c)
      .join('')
  }
  if (h.length !== 6) return `rgba(0, 0, 0, ${alpha})`
  const n = parseInt(h, 16)
  if (Number.isNaN(n)) return `rgba(0, 0, 0, ${alpha})`
  const r = (n >> 16) & 255
  const g = (n >> 8) & 255
  const b = n & 255
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const privilegeCheckboxStyles = () => {
  const accent = getAccent(defaultThemeColors)
  return {
    root: {
      color: accent,
      padding: 4,
      '&$checked': {
        color: accent,
      },
    },
    checked: {},
    disabled: {
      opacity: 0.5,
    },
  }
}
